import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { PolicyStreetBannerComponent } from '../insurance-policy-street/components/policy-street-banner/policy-street-banner.component';
import { Router } from '@angular/router';
import { PolicyStreetFormComponent } from '../insurance-policy-street/components/policy-street-form/policy-street-form.component';
import { PolicyStreetServicesComponent } from '../insurance-policy-street/components/policy-street-services/policy-street-services.component';
import { ToastrService } from 'ngx-toastr';
import { LibertyService } from '../liberty-landing/liberty.service';
import { PolicyStreetSmeBannerComponent } from './components/policy-street-sme-banner/policy-street-sme-banner.component';
import { PolicyStreetSmeServicesComponent } from './components/policy-street-sme-services/policy-street-sme-services.component';
import { PolicyStreetSmeFormComponent } from './components/policy-street-sme-form/policy-street-sme-form.component';

@Component({
    selector: 'app-insurance-policy-street-sme',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FooterComponent,
        HeaderComponent,
        PolicyStreetSmeBannerComponent,
        PolicyStreetSmeServicesComponent,
        PolicyStreetSmeFormComponent,
    ],
    templateUrl: './insurance-policy-street-sme.component.html',
    styleUrl: './insurance-policy-street-sme.component.scss',
})
export class InsurancePolicyStreetSmeComponent {
    clickedOutside: boolean = false;
    selectedLanguage: any;

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private _libertyService: LibertyService
    ) {
        this.selectedLanguage = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    /* HEADER AREA */
    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    onSubmitPolicyStreetForm(data) {
        data.orgCode = 'PSTR';
        this._libertyService.sendLibertyData(data).subscribe({
            next: (res) => {
                this.router.navigate(['/insurance/success'], {
                    queryParams: { source: 'policy-street' },
                    state: { id: res?.id },
                });
            },
            error: (err) => {
                this.toastr.error(err.error.message, 'Error');
            },
        });
    }
}
